import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import {serviceId} from "../../utils/constant";
import { sub } from '../../services/user-api';

const Main = () => {

    //const [ani, setAni] = useState();
    const navigate = useNavigate(); 
    console.log(window);
    useEffect(() => {       
        const ani="PDKSUB-200-ZpHyZcOOAARjuoUftpftXLRtQlPEUkX7VMeFEaTyktg=";
        console.log("ani="+ani);
        if(ani==null || ani==undefined || ani.length<=2)
        {
            navigate("/otp");
        }
        else
        {
            localStorage.setItem("mmuvcann", ani);
            sub({action:0,ani: ani,serviceId:serviceId}).then((res) => {
                console.log(res); 
                if(res.data.data!==null && res.data.data!==undefined)
                {
                    localStorage.setItem("token", res.data.data.accessToken);
                    window.location.href ="/home";
                }
                else   window.location.href ="/sub";
            }).catch((err) => {
                console.log(err);
                window.location.href ="/sub";
            })
        }
    }, []);
            
            

    return (
    <> </>
    )
}

export default Main